import React from 'react'
import './ProductsItem.scss'
import { Link } from 'react-router-dom'

import Wirerod from '../../assets/Pictures/Products/wirerod.jpg'
import Steelrebar from '../../assets/Pictures/Products/steelrebar.jpg'
import StandardsGalvanizedWire from '../../assets/Pictures/Products/Alambre-Galvanizado.jpg'
import Steelignot from '../../assets/Pictures/Products/Steelignot.jpg'
import EPIndustrialCooler from '../../assets/Pictures/Products/EP-Industrial-cooler.jpg'

export default function ProductsItem() {
  return (
    <div className='productsItem'>
      <div className='container'>
        <div className='row'>
          <div className='product'>
            <Link to='/wirerod' className="item">
              <img src={Wirerod} alt="Wirerod" />
              <div className="text">
                Wire Rod
              </div>
            </Link>
            <Link to='/steelrebar' className="item">
              <img src={Steelrebar} alt="Wirerod" />
              <div className="text">
                Steel Rebar
              </div>
            </Link>
            <Link to='/standardgalvanizedwire' className="item">
              <img src={StandardsGalvanizedWire} alt="Wirerod" />
              <div className="text">
                Standards Galvanized Wire
              </div>
            </Link>
            <Link to='/steelingot' className="item">
              <img src={Steelignot} alt="Wirerod" />
              <div className="text">
                Steel Ingot
              </div>
            </Link>
          </div>
          <div className='product' style={{ justifyContent: 'right', marginTop: '1em' }}>
            <Link to='/EPIndustrialCooler' className="item">
              <img src={EPIndustrialCooler} alt="Wirerod" />
              <div className="text">
                EP Industrial cooler
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
